/// <reference path="../include.ts" />

namespace project_common {

	import View = alm.view.View;

	export class StatusError extends View<JQuery> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
			super(jQuery('#status-error'));
			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():JQuery {
			const view = this.getView();

			this.message = view.find('.message');
			this.titleText = this.message.find('.title-text');
			this.descriptionText = this.message.find('.description-text');
			this.buttonText = this.message.find('.button-text');

			return view;
		}

		protected implReady():void {
		}

		protected implFinalize():void {
		}

		protected implShow(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.css('display', 'block');
			});
		}

		protected implHide(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.css('display', 'none');
			});
		}





		public clearContext():void {
			this.titleText.text('');
			this.descriptionText.text('');
			this.buttonText.text('');
		}

		public setContext():void {
			this.clearContext();
			const lang = Application.getPresetContext().lang;

			this.titleText.text(DataParser.localize(CommonLocalizable.loadErrorTitle, lang));
			this.descriptionText.text(DataParser.localize(CommonLocalizable.loadErrorDescription, lang));
			this.buttonText.text(DataParser.localize(CommonLocalizable.loadErrorAction, lang));
		}





		// --------------------------------------------------
		//
		// MEMBER
		//
		// --------------------------------------------------

		private message:JQuery;
		private titleText:JQuery;
		private descriptionText:JQuery;
		private buttonText:JQuery;
	}
}
